// index.ts
import SubscriptionFeaturesList from './SubscriptionFeaturesList';
import SubscriptionFeaturesCreate from './SubscriptionFeaturesCreate';
import SubscriptionFeaturesEdit from './SubscriptionFeaturesEdit';

export default {
  list: SubscriptionFeaturesList,
  create: SubscriptionFeaturesCreate,
  edit: SubscriptionFeaturesEdit,
};